import { render } from "./GzList.vue?vue&type=template&id=4a53eb6c&scoped=true"
import script from "./GzList.vue?vue&type=script&lang=js"
export * from "./GzList.vue?vue&type=script&lang=js"

import "./GzList.vue?vue&type=style&index=0&id=4a53eb6c&scoped=true&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a53eb6c"]])

export default __exports__